module.exports = __webpack_public_path__ + "img/value_icon_one.82adf70e.png";